import script from "./dropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./dropdown.vue?vue&type=script&setup=true&lang=js"

import "./dropdown.vue?vue&type=style&index=0&id=0dc7de38&lang=scss&scoped=true"

import exportComponent from "/app/ViewpointPBIEmbedded/ViewpointPBIEmbedded.BFF/ClientApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dc7de38"]])

export default __exports__